import { apiReturnPaginatedResults, apiReturnResults } from '../../apiFactory/apiReturn';
import { getRequest, postRequest } from '../../common/api/requests/request';
import {
    type AddItemResponse,
    type ApiResult,
    type BaseParams,
    type CallParams,
    type LineupItemPayload,
    type PaginatedResult,
    type PostParams,
    type WishlistAudit,
    type WishlistAuditQuery,
    type WishlistItemAudit,
    type WishlistItemAuditQuery,
} from '../../common/structs';
import { links } from '../../links';

type AddLineupItemParams = BaseParams & PostParams<LineupItemPayload> & { inviteCode?: string };
type QueryWishlistParams = CallParams<WishlistAuditQuery>;
type QueryWishlistItemParams = CallParams<WishlistItemAuditQuery> & { type: 'item' | 'list' };

export async function addLineupItem(params: AddLineupItemParams): Promise<ApiResult<AddItemResponse>> {
    const { value, inviteCode, ...rest } = params;
    return postRequest({
        value,
        ...rest,
        target: links.fantasy.lineupItems('', inviteCode),
    });
}

export async function lineupAudit(params: QueryWishlistParams): Promise<ApiResult<PaginatedResult<WishlistAudit>>> {
    return getRequest({
        ...params,
        target: links.admin().audit.items, // TODO: replace with links.wishlists.audit.wishlist when BE updated
    });
}

export async function lineupItemAudit(
    params: QueryWishlistItemParams,
): Promise<ApiResult<PaginatedResult<WishlistItemAudit>>> {
    return getRequest({
        ...params,
        target: links.wishlists.audit.items,
    });
}

export const callAddLineupItem = (params: AddLineupItemParams) =>
    apiReturnResults<AddItemResponse>(addLineupItem, params);
export const callAuditLineup = (params: QueryWishlistItemParams) =>
    apiReturnPaginatedResults<WishlistAudit>(lineupAudit, params);

export const callAuditLineupItems = (params: QueryWishlistItemParams) =>
    apiReturnPaginatedResults<WishlistItemAudit>(lineupItemAudit, params);
